<script setup lang="ts">
import { Star } from 'lucide-vue-next'

const props = withDefaults(
  defineProps<{
    rating: number
    size?: 'sm' | 'md'
  }>(),
  { size: 'sm' }
)

const sizeClass = computed(() => (props.size === 'md' ? 'size-5' : 'size-4'))
</script>

<template>
  <div class="inline-flex items-center gap-0.5" :aria-label="`${rating} / 5`">
    <Star
      v-for="i in 5"
      :key="i"
      :class="[
        sizeClass,
        i <= rating ? 'fill-amber-400 text-amber-400' : 'fill-muted-foreground/30 text-muted-foreground/30'
      ]"
    />
  </div>
</template>
